(function () {
  'use strict';

  angular.module('clientDashboardApp.admin.userRoles.userRoleService', []).factory('userRoleService', function ($q, $http) {

    return {
      getUserRoles: () => $http.get('/v5/userRoles'),
      updateUserRoles: userRoles => $http.post('/v5/userRoles', userRoles),
      getAllPermissions: () => $http.get('/v5/allPermissions'),
    }

  })
})()
